export default __webpack_public_path__ + "static/media/aboutUs-abr@2x.901b1ed7.png";